import axios from 'axios'
import router from '@/router'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getCustomerToken } from '@/utils/auth'

const saasservice = axios.create({
  baseURL: '/xc',
  timeout: 0
})

saasservice.interceptors.request.use(
  config => {
    if (store.getters.CustomerToken) {
      config.headers['Authorization'] = 'Bearer '+getCustomerToken()
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

saasservice.interceptors.response.use(
  response => {
    const res = response.data

    return res
  },
  error => {
    if(error.response.status==401){
        Message({
            message: '登录信息已过期请重新登录。',
            type: 'error',
            duration: 5 * 1000
        })
        router.push({
            path: '/',
            query: ''
        })
    }else{
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
    }
    return Promise.reject(error)
  }
)

export default saasservice



// WEBPACK FOOTER //
// ./src/utils/saasrequest.js